import React from "react";
import { Loader, Segment, Provider } from "@fluentui/react-northstar";

const LoadingDialog = (props) => {
  return (
    <Provider.Consumer
      render={(theme) => (
        <Segment data-testid="loadingDialog" className={"segment " + theme.siteVariables.themeString}>
          <Loader label={props.content} labelPosition="below" />
        </Segment>
      )}
    ></Provider.Consumer>
  );
};

export default LoadingDialog;
